import { post, fetch, simulate } from '../../../data/shared/api_utils';
import URI from 'urijs';
import isEmpty from 'lodash/isEmpty';
//import faker from 'faker/locale/fr';
import isArray from 'lodash/isArray';

export const fetchUserSession = () => fetch('/api/security/customer');

export const fetchRoutes = (filters = {}) =>
{
    const url = new URI('/api/reservation-request/route');
    buildQueryFilters(url, filters);

    return fetch(url.toString());
};

export const fetchLines = () => {
    const url = new URI('/api/reservation-request/route');
    buildQueryFilters(url, {'regular-shuttle': true});

    return fetch(url.toString());
}

export const searchHikes = (query, locale = 'fr') => {
    const url = new URI('/carto/hikes/'+locale);
    if(query) {
        url.addSearch('q', query);
    }
    return fetch(url.toString());
}

export const suggestPlace = (query, filters = {}) => {
    const url = new URI('/api/reservation-request/suggest/place');

    if (!isEmpty(query)) {
        url.addSearch('q', query);
    }

    buildQueryFilters(url, filters);

    return fetch(url.toString());
};

export const suggestStop = (query, filters = {}) => {
    const url = new URI('/api/reservation-request/suggest/stop');

    if (null !== query && '' !== query) {
        url.addSearch('q', query);
    }

    buildQueryFilters(url, filters);

    return fetch(url.toString());
};

export const suggestRegularShuttleDeparture = (query, filters = {}) => {
    const url = new URI('/api/regular-shuttle/suggest/departure');

    if (null !== query && '' !== query) {
        url.addSearch('q', query);
    }

    buildQueryFilters(url, filters);

    return fetch(url.toString());
};

export const suggestRegularShuttleJourney = (query, filters = {}) => {
    const url = new URI('/api/regular-shuttle/suggest/journey');

    if (null !== query && '' !== query) {
        url.addSearch('q', query);
    }

    buildQueryFilters(url, filters);

    return fetch(url.toString());
};

const buildQueryFilters = (url, filters = {}) => {
    Object.keys(filters).map(name => {
        if (null !== filters[name]) {
            if (isArray(filters[name])) {
                filters[name].forEach(filter => url.addSearch(`filters[${name}][]`, filter));
            } else {
                url.addSearch(`filters[${name}]`, filters[name]);
            }
        }
    });
};

// simulation
/*
const getFakeLine = () => ({
    id: faker.random.uuid(),
    label: faker.random.word(),
    color: faker.random.arrayElement([
        '#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3', '#03a9f4',
        '#00bcd4', '#009688', '#4caf50', '#8bc34a', '#cddc39', '#ffeb3b', '#ffc107',
        '#ff9800', '#ff5722', '#795548', '#607d8b'
    ])
});

const linesResponse = {
    valid: true,
    data: [
        getFakeLine(),
        getFakeLine(),
        getFakeLine(),
        getFakeLine(),
        getFakeLine(),
        getFakeLine(),
        getFakeLine()
    ]
};
*/
// simulate
//export const fetchLines = () => simulate(linesResponse);